import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface RelatedPartyDisclosureRommsProps {
  onBack: () => void;
}

export default function RelatedPartyDisclosureRomms({ onBack }: RelatedPartyDisclosureRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Related Party Disclosure" />;
}
